import styled from 'styled-components'

const WalidacjaSuccessStyle = styled.section`
  margin: auto;
  height: 756px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h5 {
    text-align: center;
    height: 36px;
    margin: 0;
  }

  h4 {
    margin-bottom: 12px;
    text-align: center;
    margin: 8px;
  }

  p {
    text-align: center;
    margin: 20px 0 0 0;
  }

  .link {
    margin: 4px 0 16px 0;
    color: ${props => props.theme.palette.primary.main};
  }
`
export default WalidacjaSuccessStyle
